"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Quilt = exports.BlockInfo = exports.CellList = exports.Cell = exports.Palette = exports.Border = exports.Guide = exports.Rect = exports.RectBounds = exports.Point = exports.SashInfo = exports.GuideType = exports.Sashes = void 0;
const BLOCKS_HORIZ = 4;
const BLOCKS_VERT = 5;
var Sashes;
(function (Sashes) {
    Sashes[Sashes["None"] = 0] = "None";
    Sashes[Sashes["Single"] = 1] = "Single";
    Sashes[Sashes["Double"] = 2] = "Double";
})(Sashes || (exports.Sashes = Sashes = {}));
var GuideType;
(function (GuideType) {
    GuideType[GuideType["None"] = 0] = "None";
    GuideType[GuideType["Grid"] = 1] = "Grid";
})(GuideType || (exports.GuideType = GuideType = {}));
class SashInfo {
    levels = Sashes.None;
    colors = ["#001", "#002"];
}
exports.SashInfo = SashInfo;
class Point {
    x;
    y;
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
}
exports.Point = Point;
class RectBounds {
    w;
    h;
    constructor(w, h) {
        this.w = w;
        this.h = h;
    }
    toString() {
        const w = typeof this.w === "number" ? this.w : "-";
        const h = typeof this.h === "number" ? this.h : "-";
        return `${w}×${h}`;
    }
}
exports.RectBounds = RectBounds;
class Rect extends RectBounds {
    w;
    h;
    constructor(w, h) {
        super(w, h);
        this.w = w;
        this.h = h;
    }
    scale(m) {
        return new Rect(m * this.w, m * this.h);
    }
}
exports.Rect = Rect;
class Guide {
    constructor(guideType) {
        this.type = guideType;
    }
    _type;
    get type() {
        return this._type;
    }
    set type(value) {
        if (value === "") {
            this._type = GuideType.None;
        }
        else {
            this._type = GuideType.Grid;
            this._color = value;
        }
    }
    _color;
    get color() {
        return this._color;
    }
    equals(other) {
        return other && this._type === other.type && this._color === other.color;
    }
    copy() {
        const htmlType = this._type === GuideType.Grid ? this._color : "";
        return new Guide(htmlType);
    }
}
exports.Guide = Guide;
class Border {
    cellWidth;
    color;
    constructor(cellWidth, color) {
        this.cellWidth = cellWidth;
        this.color = color;
    }
    equals(other) {
        return other && this.cellWidth === other.cellWidth && this.color === other.color;
    }
}
exports.Border = Border;
class Palette extends Array {
    equals(other) {
        if (!(other && this.length === other.length)) {
            return false;
        }
        for (let i = 0; i < this.length; i++) {
            if (this[i] !== other[i]) {
                return false;
            }
        }
        return true;
    }
    copy() {
        return new Palette(...this);
    }
}
exports.Palette = Palette;
class Cell {
    colors;
    constructor(top, right, bottom, left) {
        this.colors = [top, right, bottom, left];
    }
    copy() {
        return new Cell(...this.colors);
    }
    rotateCW() {
        const c = this.colors;
        this.colors = [c[3], c[0], c[1], c[2]];
        return this;
    }
    rotateCCW() {
        const c = this.colors;
        this.colors = [c[1], c[2], c[3], c[0]];
        return this;
    }
    flipHoriz() {
        const c = this.colors;
        this.colors = [c[0], c[3], c[2], c[1]];
        return this;
    }
    flipVert() {
        const c = this.colors;
        this.colors = [c[2], c[1], c[0], c[3]];
        return this;
    }
}
exports.Cell = Cell;
class CellList extends Array {
    copy() {
        return new CellList(...this.map((v) => v.copy()));
    }
    getSize() {
        return Math.floor(Math.sqrt(this.length));
    }
}
exports.CellList = CellList;
class BlockInfo {
    dirty = true;
    cells;
    canvas;
    lastColors;
    lastPixelSize;
    savedCells;
    constructor() {
        this.cells = new CellList();
        this.savedCells = this.cells.copy();
        this.canvas = document.createElement("canvas");
    }
    getSize() {
        return this.cells.getSize();
    }
    isDirty() {
        return this.dirty;
    }
    renderTo(canvas, colors, fuzz) {
        this.draw(canvas, colors, fuzz || 0);
    }
    getSource(pixelSize, colors) {
        if (!colors.equals(this.lastColors)) {
            this.dirty = true;
            this.lastColors = colors.copy();
        }
        if (this.lastPixelSize !== pixelSize) {
            this.dirty = true;
            this.lastPixelSize = pixelSize;
            this.canvas.width = pixelSize;
            this.canvas.height = pixelSize;
        }
        if (this.dirty) {
            this.draw(this.canvas, colors);
        }
        return this.canvas;
    }
    getScaledSource(scaledSize) {
        if (this.dirty) {
            this.draw(this.canvas, this.lastColors);
        }
        const target = document.createElement("canvas");
        target.width = scaledSize;
        target.height = scaledSize;
        const ctx = target.getContext("2d", { alpha: false });
        ctx.drawImage(this.canvas, 0, 0, scaledSize, scaledSize);
        return target;
    }
    spinCell(i, leftward) {
        if (i >= this.cells.length) {
            return;
        }
        if (leftward) {
            this.cells[i].rotateCCW();
        }
        else {
            this.cells[i].rotateCW();
        }
        this.dirty = true;
    }
    flipCell(i, vertical) {
        if (i >= this.cells.length) {
            return;
        }
        if (vertical) {
            this.cells[i].flipVert();
        }
        else {
            this.cells[i].flipHoriz();
        }
        this.dirty = true;
    }
    paintSubCell(i, j, color) {
        if (i >= this.cells.length || i < 0 || color < 0) {
            return;
        }
        if (this.cells[i].colors[j] === color) {
            return;
        }
        this.cells[i].colors[j] = color;
        this.dirty = true;
    }
    resize(toSize) {
        const currentSize = this.cells.getSize();
        if (toSize === currentSize) {
            return;
        }
        this.saveCurrentCells();
        if (toSize > currentSize) {
            this.resizeUp(currentSize, toSize);
            if (this.savedCells.getSize() < toSize) {
                this.savedCells = this.cells.copy();
            }
        }
        else {
            this.resizeDown(toSize);
        }
        this.dirty = true;
    }
    rollLeft() {
        const sz = this.cells.getSize();
        this.roll(function (row, col) {
            return [row, (col + 1) % sz];
        });
    }
    rollRight() {
        const sz = this.cells.getSize();
        this.roll(function (row, col) {
            return [row, col ? col - 1 : sz - 1];
        });
    }
    rollUp() {
        const sz = this.cells.getSize();
        this.roll(function (row, col) {
            return [(row + 1) % sz, col];
        });
    }
    rollDown() {
        const sz = this.cells.getSize();
        this.roll(function (row, col) {
            return [row ? row - 1 : sz - 1, col];
        });
    }
    saveCurrentCells() {
        const saved = this.savedCells;
        const current = this.cells;
        const currentSize = current.getSize();
        const savedSize = saved.getSize();
        if (savedSize <= currentSize) {
            this.savedCells = this.cells.copy();
            return;
        }
        const skip = savedSize - currentSize;
        for (let row = 0, i = 0, j = 0; row < currentSize; row++) {
            for (let col = 0; col < currentSize; col++) {
                saved[j++] = current[i++];
            }
            j += skip;
        }
    }
    resizeUp(currentSize, toSize) {
        const current = this.cells;
        const saved = this.savedCells;
        const savedSize = saved.getSize();
        const fillSize = Math.min(savedSize, toSize);
        const output = new CellList(toSize * toSize);
        const nColors = this.lastColors ? this.lastColors.length : 3;
        let row, col, siCurrent, siSaved;
        let di = 0;
        for (row = 0, siCurrent = 0; row < currentSize; row++) {
            for (col = 0; col < currentSize; col++) {
                output[di++] = current[siCurrent++];
            }
            for (siSaved = row * savedSize + currentSize; col < fillSize; col++) {
                output[di++] = saved[siSaved++];
            }
            for (; col < toSize; col++) {
                output[di++] = randomCell(nColors);
            }
        }
        for (siSaved = row * savedSize; row < fillSize; row++) {
            for (col = 0; col < savedSize; col++) {
                output[di++] = saved[siSaved++];
            }
            for (; col < toSize; col++) {
                output[di++] = randomCell(nColors);
            }
        }
        for (; row < toSize; row++) {
            for (col = 0; col < toSize; col++) {
                output[di++] = randomCell(nColors);
            }
        }
        this.cells = output;
    }
    resizeDown(toSize) {
        const input = this.cells;
        const output = new CellList(toSize * toSize);
        const skip = this.cells.getSize() - toSize;
        let di = 0;
        let si = 0;
        for (let row = 0; row < toSize; row++) {
            for (let col = 0; col < toSize; col++) {
                output[di++] = input[si++];
            }
            si += skip;
        }
        this.cells = output;
    }
    roll(mappingFn) {
        const output = new CellList(this.cells.length);
        const size = this.cells.getSize();
        let i = 0;
        for (let row = 0; row < size; row++) {
            for (let col = 0; col < size; col++) {
                const [readRow, readCol] = mappingFn(row, col);
                output[i++] = this.cells[readCol + readRow * size];
            }
        }
        this.cells = output;
        this.savedCells = new CellList();
        this.dirty = true;
    }
    draw(canvas, colors, fuzz = 0) {
        const cells = this.cells;
        const size = cells.getSize();
        const cellPx = canvas.width / size;
        let oX, oY, iBlock;
        const ctx = canvas.getContext("2d", { alpha: false });
        iBlock = 0;
        for (let cY = 0; cY < size; ++cY) {
            oY = cY * cellPx;
            for (let cX = 0; cX < size; ++cX) {
                oX = cX * cellPx;
                drawCellAt(ctx, oX, oY, cellPx, colors, cells[iBlock++], fuzz);
            }
        }
        if (canvas === this.canvas) {
            this.dirty = false;
        }
    }
}
exports.BlockInfo = BlockInfo;
class Quilt {
    blocks = [new BlockInfo()];
    borders = [];
    colorSet = new Palette();
    sash = new SashInfo();
    #shape;
    blockMap;
    constructor(size) {
        this.#shape = size || new Rect(BLOCKS_HORIZ, BLOCKS_VERT);
        this.blockMap = this.newBlockMap(this.#shape);
    }
    get shape() {
        return this.#shape;
    }
    getHeightForWidth(width) {
        let addedCellsW = 0;
        let addedCellsH = 0;
        let cellsPerBlock = this.blocks[0].getSize();
        for (const border of this.borders) {
            addedCellsW += border.cellWidth;
            addedCellsH += border.cellWidth;
        }
        if (this.sash.levels !== Sashes.None) {
            addedCellsW += this.#shape.w - 1;
            addedCellsH += this.#shape.h - 1;
        }
        const w = (this.#shape.w * cellsPerBlock) + addedCellsW;
        const h = (this.#shape.h * cellsPerBlock) + addedCellsH;
        return ((width / w) * h) | 0;
    }
    *[Symbol.iterator]() {
        const w = this.#shape.w;
        const h = this.#shape.h;
        for (let r = 0; r < h; r++) {
            yield this.blockMap[r].slice(0, w);
        }
    }
    get blockCells() {
        return this.blocks[0].getSize();
    }
    set blockCells(size) {
        for (const block of this.blocks) {
            block.resize(size);
        }
    }
    resize(toShape) {
        const bmW = this.blockMap[0].length;
        const bmH = this.blockMap.length;
        const dW = toShape.w - bmW;
        const dH = toShape.h - bmH;
        if (dW <= 0 && dH <= 0) {
            this.#shape = toShape;
            return;
        }
        if (dW > 0) {
            for (let r = 0; r < bmH; r++) {
                const items = (new Array(dW)).fill(0);
                this.blockMap[r].push(...items);
            }
        }
        if (dH > 0) {
            const w = Math.max(toShape.w, bmW);
            for (let r = bmH; r < toShape.h; r++) {
                this.blockMap.push((new Array(w)).fill(0));
            }
        }
        this.#shape = toShape;
    }
    newBlockMap(size) {
        const rows = size.h;
        const cols = size.w;
        const m = [];
        for (let r = 0; r < rows; r++) {
            m.push((new Array(cols)).fill(0));
        }
        return m;
    }
}
exports.Quilt = Quilt;
function randomCell(colorCount) {
    return new Cell(Math.floor(Math.random() * colorCount), Math.floor(Math.random() * colorCount), Math.floor(Math.random() * colorCount), Math.floor(Math.random() * colorCount));
}
function drawTriangle(ctx, points, fillStyle, fuzz) {
    const absFuzz = Math.abs(fuzz);
    ctx.beginPath();
    ctx.moveTo(points[0].x, points[0].y);
    ctx.lineTo(points[1].x + fuzz, points[1].y - absFuzz);
    ctx.lineTo(points[2].x + fuzz, points[2].y + absFuzz);
    ctx.closePath();
    ctx.fillStyle = fillStyle;
    ctx.fill();
}
function drawRect(ctx, point, rect, fillStyle) {
    ctx.fillStyle = fillStyle;
    ctx.fillRect(point.x, point.y, rect.w, rect.h);
}
function drawCellAt(ctx, oX, oY, cellPx, palette, cell, fuzz = 0) {
    const half = cellPx / 2;
    const tl = new Point(oX, oY);
    const tr = new Point(oX + cellPx, oY);
    const bl = new Point(oX, oY + cellPx);
    const br = new Point(oX + cellPx, oY + cellPx);
    const c = new Point(oX + half, oY + half);
    const ml = new Point(oX, oY + half);
    const rect = new Rect(cellPx, half + fuzz);
    drawRect(ctx, tl, rect, palette[cell.colors[0]]);
    drawRect(ctx, ml, rect, palette[cell.colors[2]]);
    drawTriangle(ctx, [c, tr, br], palette[cell.colors[1]], fuzz);
    drawTriangle(ctx, [c, bl, tl], palette[cell.colors[3]], -fuzz);
}
